import { CoreRequest } from '../../../infrastructure';

export default async function ClaimFileUploadAdapter(requestUrl, contentType, file) {
    const execute = async (requestUrl, contentType, file) => {
        // const req = {
        //     requestUrl,
        //     body
        // };
        // const response = await CoreRequest(req);

        const response = await fetch(requestUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': contentType
            },
            body: file
        });

        return response;
    };

    try {
        return execute(requestUrl, contentType, file);
    } catch (error) {
        console.error('Error', error);
        throw new Error(`failed: ${error}`);
    }
}
